export function isSelectArrayEmpty(value: any[]) {
  return !value || !Array.isArray(value) || value.length === 0
    ? 'This field is required'
    : ''
}

export function isSelectEmpty(value: string) {
  return !value.length ? 'This field is required' : ''
}
